// src/admin/bars/AdminLayout.tsx
import React from 'react';
import AdminNavbar from './AdminNavbar';
import AdminSidebar from './AdminSidebar';
import { Outlet } from 'react-router-dom'; // <--- NEW: Import Outlet for nested routes

// REMOVED: import { AdminProvider } from '../context/AdminContext'; // No longer needed
// REMOVED: interface AdminLayoutProps { children: React.ReactNode; } // No longer needed

const AdminLayout: React.FC = () => { // <--- MODIFIED: Removed <AdminLayoutProps>
  return (
    // REMOVED: <AdminProvider> {/* No longer needed, AuthProvider is higher up */}
      <div className="min-h-screen bg-gradient-to-br from-yellow-50 to-amber-100 flex flex-col">
        {/* Navbar */}
        <AdminNavbar />

        <div className="flex flex-1 pt-16">
          {/* Sidebar */}
          <AdminSidebar />

          {/* Main Content Area */}
          <main className="flex-1 p-8 ml-64 overflow-y-auto">
            <Outlet /> {/* <--- MODIFIED: Render Outlet for nested routes */}
          </main>
        </div>
      </div>
    // REMOVED: </AdminProvider>
  );
};

export default AdminLayout;